import { CommonModule } from '@angular/common';

import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import moment from 'moment';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { CascadeSelectModule } from 'primeng/cascadeselect';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { MultiSelectModule } from 'primeng/multiselect';
import { SelectButtonModule } from 'primeng/selectbutton';
import { StepsModule } from 'primeng/steps';
import { TabMenuModule } from 'primeng/tabmenu';
import { TabViewModule } from 'primeng/tabview';
import { TagModule } from 'primeng/tag';
import { ToastModule } from 'primeng/toast';
import { AcademyAdministratorOperation } from '../../../../model/administrator/AcademyAdministratorOperation';
import { AcademyAdministratorType } from '../../../../model/administrator/AcademyAdministratorType';
import { AdministratorEntity } from '../../../../model/administrator/AdministratorEntity';
import { Discount } from '../../../../model/administrator/AgreementsAndDiscounts/Discount';
import { Application } from '../../../../model/Application';
import { Documento } from '../../../../model/documento';
import { ApplicationType } from '../../../../model/enum/ApplicationType';
import { HttpResponse } from '../../../../model/HttpResponse';
import { Member } from '../../../../model/member';

import uuid4 from 'uuid4';
import { Product } from '../../../../model/administrator/ProductAndServices/Product';
import { PaymentResponseStatus } from '../../../../model/payment/PaymentReponseStatus';
import { ProcessStatus } from '../../../../model/ProcessStage';
import { Transfer } from '../../../../model/transfer/Transfer';
import { AdministrationService } from '../../../../services/administration.service';
import { ApplicationService } from '../../../../services/application.service';
import { DocumentsService } from '../../../../services/documents.service';
import { GestionService } from '../../../../services/gestion.service';
import { LoadingService } from '../../../../services/loading.service';

@Component({
  selector: 'app-transfer-review',
  standalone: true,
  imports: [
    ConfirmDialogModule,
    DropdownModule,
    StepsModule,
    TabMenuModule,
    CommonModule,
    CardModule,
    ButtonModule,
    TabViewModule,
    DialogModule,
    SelectButtonModule,
    FormsModule,
    CascadeSelectModule,
    ToastModule,
    InputTextareaModule,
    TagModule,
    MultiSelectModule,
  ],
  providers: [ConfirmationService, MessageService],
  templateUrl: './transfer-review.component.html',
  styleUrl: './transfer-review.component.scss',
})
export class TransferReviewComponent {
  activeIndex: number = 0;
  documentPreviewSelected: any = null;
  showDocumentPreview: boolean = false;
  transferApplication!: Application;
  showApplicationDetail: boolean = false;
  member!: Member;
  @Input()
  transfer!: Transfer;

  @Output()
  goToBackEvent: EventEmitter<boolean> = new EventEmitter();

  stateOptions: any[] = [
    {
      label: 'Aprobar Solicitud',
      value: ProcessStatus.ACCEPTED_PAYMENT_PENDING,
    },
    { label: 'Rechazar Solicitud', value: ProcessStatus.REJECTED },
  ];

  confirmationResponse: ProcessStatus = ProcessStatus.ACCEPTED_PAYMENT_PENDING;
  productosAsignados: Product[] = [];
  descuentos: Discount[] = [];

  rejectComments: string = '';
  productos: Product[] = [];

  constructor(
    private documentsService: DocumentsService,
    private sanitizer: DomSanitizer,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private loadingService: LoadingService,
    private applicationService: ApplicationService,
    private administrationService: AdministrationService,
    private gestionService: GestionService
  ) {}

  ngOnInit(): void {
    this.buildMasterOptions();
    this.getMember();
  }

  calculateYearsOld(birthDay: string) {
    return moment().diff(birthDay, 'years');
  }

  showPreview(documento: Documento) {
    this.loadingService.showLoading();
    this.documentsService
      .getDocument(documento.documentId)
      .subscribe((res: HttpResponse) => {
        this.loadingService.hideLoading();
        this.documentPreviewSelected = {
          documentName: 'Carta de Libertad',
          base64: this.sanitizer.bypassSecurityTrustResourceUrl(
            res.response.filestream
          ),
        };
        this.showDocumentPreview = true;
      });
  }

  async buildMasterOptions() {
    //this.courses = await this.getCourses();
    this.productos = await this.getProducts();
  }

  async getProducts(): Promise<Product[]> {
    const groupData = await this.getEntity(
      AcademyAdministratorType.PRODUCTS_SERVICES,
      true,
      'isActive'
    );
    return groupData as Product[];
  }

  async getMember() {
    this.loadingService.showLoading();
    let entity: AdministratorEntity = {
      operation: AcademyAdministratorOperation.SELECT,
      payload: {
        options: {
          conditionals: [
            {
              conditionalConnector: null,
              logicOperator: '=',
              evaluatedProperty: 'idType',
              parameterName: '@Option1',
              parameterValue: this.transfer.member.idType,
            },
            {
              conditionalConnector: 'AND',
              logicOperator: '=',
              evaluatedProperty: 'idNumber',
              parameterName: '@Option2',
              parameterValue: this.transfer.member.idNumber,
            },
          ],
        },
      },
      type: AcademyAdministratorType.MEMBERS,
    };
    this.gestionService.sendRequest(entity).subscribe((res: HttpResponse) => {
      if (res.response.length > 0) {
        this.member = res.response[0];
      }
      this.showApplicationDetail = true;
      this.loadingService.hideLoading();
    });
  }

  async getEntity(
    academyAdministratorType: AcademyAdministratorType,
    value: any,
    property?: string
  ): Promise<any[]> {
    return new Promise<any[]>((resolve, reject) => {
      this.loadingService.showLoading();

      let data: any[] = [];
      let entity: AdministratorEntity = {
        operation: AcademyAdministratorOperation.SELECT,
        payload: {
          options: {
            conditionals: [
              {
                conditionalConnector: null,
                logicOperator: '=',
                evaluatedProperty: property || 'id',
                parameterName: '@Option1',
                parameterValue: value,
              },
            ],
          },
        },
        type: academyAdministratorType,
      };
      try {
        this.administrationService
          .sendRequest(entity)
          .subscribe((res: HttpResponse) => {
            if (res.response.length > 0) {
              data = res.response as any[];
            }
            resolve(data);
            this.loadingService.hideLoading();
          });
      } catch (error) {
        reject(error);
      }
    });
  }

  async getEntityGestion(
    academyAdministratorType: AcademyAdministratorType,
    value: any,
    property?: string
  ): Promise<any[]> {
    return new Promise<any[]>((resolve, reject) => {
      let data: any[] = [];
      let entity: AdministratorEntity = {
        operation: AcademyAdministratorOperation.SELECT,
        payload: {
          options: {
            conditionals: [
              {
                conditionalConnector: null,
                logicOperator: '=',
                evaluatedProperty: property || 'id',
                parameterName: '@Option1',
                parameterValue: value,
              },
            ],
          },
        },
        type: academyAdministratorType,
      };
      try {
        this.gestionService
          .sendRequest(entity)
          .subscribe((res: HttpResponse) => {
            if (res.response.length > 0) {
              data = res.response as any[];
            }
            resolve(data);
          });
      } catch (error) {
        reject(error);
      }
    });
  }

  sendResponse(event: Event) {
    if (!this.confirmationResponse) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atención',
        detail: 'Debe completar todos los campos requeridos para continuar',
      });
    } else {
      this.confirmationService.confirm({
        target: event.target as EventTarget,
        message: `Esta seguro de enviar la respuesta de la solicitud con estado ${
          this.confirmationResponse === ProcessStatus.ACCEPTED_PAYMENT_PENDING
            ? 'Aprobada'
            : this.confirmationResponse === ProcessStatus.REJECTED
            ? 'Rechazada'
            : this.confirmationResponse
        }`,
        header: 'Confirmar envío de respuesta',
        icon: 'pi pi-exclamation-triangle',
        acceptIcon: 'none',
        rejectIcon: 'none',
        acceptLabel: 'Si',
        rejectLabel: 'No',
        rejectButtonStyleClass: 'p-button-text',
        accept: () => {
          if (this.transfer?.process) {
            if (
              this.confirmationResponse ===
              ProcessStatus.ACCEPTED_PAYMENT_PENDING
            ) {
              // Instanciar nueva aplicación con datos de la transferencia y del member

              this.transferApplication = {
                applicant: {
                  name: this.member.name,
                  lastName: this.member.lastName,
                  idType: this.member.idType,
                  idNumber: this.member.idNumber,
                  gender: this.member.gender,
                  birthDay: this.member.birthDay,
                  birthPlace: this.member.birthPlace || '',
                  assistanceInformation: {
                    bloodType: this.member.assistanceInformation.bloodType,
                    insurance: this.member.assistanceInformation.insurance,
                    emergencyContactName:
                      this.member.assistanceInformation.emergencyContactName ||
                      'No Registra',
                    emergencyContactNumber:
                      this.member.assistanceInformation
                        .emergencyContactNumber || 'No Registra',
                  },
                  contactInformation: {
                    address: this.member.contactInformation.address,
                    city: this.member.contactInformation.city || 'No Registra',
                    email: this.member.contactInformation.email,
                    mobile: this.member.contactInformation.mobile,
                    telephone: this.member.contactInformation.mobile,
                    neighborhood: this.member.contactInformation.neighborhood,
                  },
                },
                club: this.transfer.club!,
                modalidad: this.transfer.modalidad,
                rol: this.transfer.rol,
                nivel: this.member.nivel,
                documents: {
                  docmuentsToSend:
                    this.transfer.documents.documentsToSend || [],
                  temporalFiles: {
                    pondFileDisclaimer: [],
                    pondFileId: [],
                    pondFileInsurance: [],
                  },
                },
                picture: this.member.picture,
                type: ApplicationType.TRANSFER,
                process: {
                  processStage: ProcessStatus.ACCEPTED_PAYMENT_PENDING,
                },
                id: uuid4(),
                payment: {
                  paymentItems: this.productosAsignados.map(
                    (product: Product) => {
                      return {
                        amount: product.price,
                        product: product.name,
                        descripcion: product.description,
                        tipo: product.type,
                        valorUnitario: product.price,
                        valorTotal: product.hasTax
                          ? product.price + product.price * product.taxValue
                          : product.price,
                        porcentajeIva: product.taxValue,
                      };
                    },
                  ),
                  paymentId: uuid4(),
                  paymentStatus: PaymentResponseStatus.PENDING,
                  paymentDate: '',
                },
                auditData: {
                  ...this.transfer.auditData,
                  modifiedBy: 'Gestor SID',
                  modifiedDate: moment().format('YYYY-MM-DD HH:mm:ss'),
                },
              };

              // create Transfer
              this.applicationService
                .saveApplication(this.transferApplication)
                .subscribe((updateResponse: HttpResponse) => {
                  if (updateResponse.code === 200) {
                    this.messageService.add({
                      severity: 'success',
                      summary: 'Envío Exitoso!',
                      detail: 'Nueva Solicitud de vinculación creada',
                      life: 1000,
                    });

                    //Actualizar transfer
                    this.transfer.process = {
                      processStage: ProcessStatus.APPROVED,
                    };
                    this.applicationService
                      .updateTransfer(this.transfer)
                      .subscribe((updateResponse: HttpResponse) => {
                        if (updateResponse.response) {
                          this.messageService.add({
                            severity: 'success',
                            summary: 'Envío Exitoso!',
                            detail: 'Solicitud de transferencia actualizada',
                            life: 1000,
                          });
                        }
                      });

                    this.loadingService.hideLoading();
                    setTimeout(() => {
                      this.goToBack();
                    }, 1000);
                  } else {
                    this.messageService.add({
                      severity: 'error',
                      summary: 'Error!',
                      detail:
                        'Ocurrió un error actualizando el estado de la solicitud, por favor inténtelo nuevamente',
                      life: 3000,
                    });
                  }
                });
            } else if (this.confirmationResponse === ProcessStatus.REJECTED) {
              this.transfer.comments = this.rejectComments;
              this.transfer.process.processStage = ProcessStatus.REJECTED;
              this.applicationService
                .updateTransfer(this.transfer)
                .subscribe((updateResponse: HttpResponse) => {
                  this.loadingService.hideLoading();
                  if (updateResponse.response) {
                    this.messageService.add({
                      severity: 'success',
                      summary: 'Envío Exitoso!',
                      detail: 'Solicitud de transferencia actualizada',
                      life: 1000,
                    });
                  }
                  setTimeout(() => {
                    this.goToBack();
                  }, 1000);
                });
            }
          }
        },
        reject: () => {
          this.messageService.add({
            severity: 'warning',
            summary: 'Sin Cambios',
            detail: 'No se realizaron cambios en la solicitud',
            life: 3000,
          });
        },
      });
    }
  }

  goToBack() {
    this.goToBackEvent.emit(true);
  }
}
